import React from 'react';
import PropTypes from 'prop-types';
import FavouriteControls from './FavouriteControls';
import { Link } from 'react-router-dom';
import { HashLink} from "react-router-hash-link";
import { AgentCardSmall } from './AgentCardSmall';
import styles from './PropertyCardSearch.scss';

const PropertyCardFooter = (props) => {
  const {
    property,
    property: {
      propertyId,
      category: propertyCategory,
      recentlySold,
    },
    propertyUrl,
    isMembers,
    isListing,
  } = props;

  if (isMembers) {
    const disableProfileWatch = !property.hasOwnProperty('clPropertyId');
    return <FavouriteControls property={property} disablePW={disableProfileWatch} isPropertyTracked={props.isPropertyTracked} />;
  }

  if (isListing) {
    const { listing: {agency} } = property;
    return <Link className="d-flex flex-grow-1" to={propertyUrl}><AgentCardSmall size="sm" agency={agency} /></Link>;
  }

  if (recentlySold) {
    const agency = property.lastSale?.sellingAgency;

    return !agency?.name && !agency?.agents?.[0]?.name ?
      <div className={`w-100 ${styles.footerLink}`}><Link to={propertyUrl}>View sale details</Link></div>:
      <Link className="d-flex flex-grow-1" to={propertyUrl}><AgentCardSmall size="sm" agency={agency} /></Link>;
  }

  return <div className={`w-100 ${styles.footerLink} ${styles.openAgentImproveLink}`}>
    <HashLink smooth to={`${propertyUrl}#property-history`} target="_blank" rel="noopener noreferrer">
      View Property History<span className={styles.openAgentExternal}/>
    </HashLink>
  </div>;
};

PropertyCardFooter.propTypes = {
  propertyUrl: PropTypes.string.isRequired,
  property: PropTypes.object.isRequired,
  isMembers: PropTypes.bool,
  isListing: PropTypes.bool.isRequired,
};

export default PropertyCardFooter;
